import React from 'react';
import Dropdown2 from './DropDown2';
import { iconsPath, imagePath } from '../../utils/imagePath';
import { Link, useNavigate } from 'react-router-dom';
import { industries } from '../../utils/constant';

export const ProductsDropdown = React.memo(
  ({ isOpen, closeModal, setIsMobileMenuOpen }) => {
    const navigate = useNavigate();

    const navigationFunction = (path) => {
      navigate(path);
      closeModal();
    };

    return (
      <Dropdown2 product={true} isOpen={isOpen} >
        <div className="flex gap-5 md:gap-0    text-white p-6  md:p-8 !rounded-[50px]">
          <div className="block md:hidden mb-5">
            <button
              onClick={() => {
                closeModal();
                setIsMobileMenuOpen(true);
              }}
              className="bg-[#252729] h-8 w-8 rounded-full flex items-center justify-center"
            >
              <img
                className="h-4 w-4 object-contain"
                src={iconsPath?.leftIcon}
                alt="menu"
              />
            </button>
          </div>

          <div
            className="flex flex-col md:grid md:gap-12 gap-4"
            style={{ gridTemplateColumns: '1fr 0.570fr' }}
          >
            {/* Spatial Grid Platform */}
            <div className="flex flex-col">
              <h1 className="text-[18px] font-bold mb-3 tracking-wide text-[#ffffff]">
                SPATIAL GRID PLATFORM
              </h1>
              <div className=" hidden md:block h-[1px] bg-[#ffffff] bg-opacity-50 mb-5"></div>
              <div className="flex flex-col md:flex-row gap-2 md:gap-6 ">
                <div className="flex flex-col gap-2 md:gap-8">
                  <div
                    onClick={() => navigationFunction('/platform-overview')}
                    className="flex items-center gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.platformOverview} alt="" />
                    </div>
                    <div className="">
                      <h2 className="font-semibold   text-sm text-[#ffffff] mb-2">
                        Platform Overview
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        XR platform for enterprise innovation & efficiency.
                      </p>
                    </div>
                  </div>
                  <div
                    onClick={() => navigationFunction('/spatial-ai')}
                    className="flex items-center gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.spatialAi} alt="" />
                    </div>
                    <div className="">
                      <h2 className="font-semibold    text-sm text-[#ffffff] mb-2">
                        Spatial AI
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        AI-driven creation for dynamic virtual experiences.{' '}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-2 md:gap-8">
                  <div
                    onClick={() => navigationFunction('/real-time-analytics')}
                    className="flex items-center gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.realtimeAnalytics} alt="" />
                    </div>
                    <div className="">
                      <h2 className="font-semibold    text-sm text-[#ffffff] mb-2">
                        Real-Time Analytics
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Instant insights for optimization
                      </p>
                    </div>
                  </div>

                  <div
                    onClick={() => navigationFunction('/multiplayer')}
                    className="flex items-center gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.multiPlayer} alt="" />
                    </div>
                    <div className="">
                      <h2 className="font-semibold   text-sm text-[#ffffff] mb-2">
                        Multiplayer
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Shared experiences in virtual spaces.
                      </p>
                    </div>
                  </div>
                  <div className=" block md:hidden h-[1px] bg-[#ffffff] opacity-50 "></div>
                </div>
              </div>
            </div>

            {/* Integration & OS */}
            <div className="flex flex-col">
              <h1 className="text-[18px] font-bold mb-3 tracking-wide text-[#ffffff]">
                INTEGRATION & OS
              </h1>
              <div className=" hidden md:block h-[1px] bg-[#ffffff] opacity-50 mb-5"></div>
              <div
                onClick={() => navigationFunction('/operating-system')}
                className="flex items-center gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
              >
                <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                  <img src={iconsPath?.operatingSystem} alt="" />
                </div>
                <div className="">
                  <h2 className="font-semibold   text-sm text-[#ffffff] mb-2">
                    Operating System
                  </h2>
                  <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                    Foundation for Spatial computing & virtual ecosystems
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dropdown2>
    );
  }
);

export const ResourcesDropdown = React.memo(
  ({ isOpen, closeModal, setIsMobileMenuOpen }) => {
    const navigate = useNavigate();
    const navigationFunction = (path) => {
      navigate(path);
      closeModal();
    };

    return (
      <Dropdown2 resources={true} isOpen={isOpen}>
        <div className="flex gap-3 md:gap-0 p-6 md:p-8 !rounded-[50px] text-white">
          <div className="block md:hidden mb-5">
            <button
              onClick={() => {
                closeModal();
                setIsMobileMenuOpen(true);
              }}
              className="bg-[#252729] h-8 w-8 rounded-full flex items-center justify-center"
            >
              <img
                className="h-4 w-4 object-contain"
                src={iconsPath?.leftIcon}
                alt="menu"
              />
            </button>
          </div>

          {/* Responsive Grid Layout */}
          <div
            className="flex flex-col md:grid md:gap-12 gap-4"
            style={{ gridTemplateColumns: '0.7fr 1fr' }}
          >
            {/* Resources */}
            <div className="flex flex-col">
              <h1 className="text-[18px] font-bold mb-3 tracking-wide text-[#ffffff]">
                Resources
              </h1>
              <div className="hidden md:block h-[1px] bg-[#ffffff] opacity-50 mb-5"></div>
              <div className="flex flex-col gap-2 md:gap-8">
                <div
                  onClick={() => navigationFunction('/documentation')}
                  className="flex items-center md:items-start gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                >
                  <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center flex-shrink-0">
                    <img src={iconsPath?.documentation} alt="" />
                  </div>
                  <div className="text-left cursor-pointer">
                    <h2 className="font-semibold text-sm text-[#ffffff] mb-2">
                      Documentation & Support
                    </h2>
                    <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                      Resources and guidance to help you build, deploy, <br />{' '}
                      and troubleshoot with Spatial Grid.
                    </p>
                  </div>
                </div>

                <div
                  onClick={() => navigationFunction('/help-center')}
                  className="flex items-center md:items-start gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                >
                  <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center flex-shrink-0">
                    <img src={iconsPath?.helpCenter} alt="" />
                  </div>
                  <div className="text-left cursor-pointer">
                    <h2 className="font-semibold text-sm text-[#ffffff] mb-2">
                      Help Center
                    </h2>
                    <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                      Quick answers, how-tos, and resources at <br /> your
                      fingertips.
                    </p>
                  </div>
                </div>

                <div className="block md:hidden h-[1px] bg-[#ffffff] opacity-50"></div>
              </div>
            </div>

            {/* Research & Blogs */}
            <div className="flex flex-col">
              <h1 className="text-[18px] font-bold mb-3 tracking-wide text-[#ffffff]">
                Research & Blogs
              </h1>
              <div className="hidden md:block h-[1px] bg-[#ffffff] bg-opacity-50 mb-5"></div>
              <div className="flex flex-col md:flex-row gap-2 md:gap-10">
                <div className="flex flex-col gap-2 md:gap-8">
                  <div
                    onClick={() => navigationFunction('/resource/blogs')}
                    className="flex items-center md:items-start gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center flex-shrink-0">
                      <img src={iconsPath?.spatialgridBlog} alt="" />
                    </div>
                    <div className="text-left cursor-pointer">
                      <h2 className="font-semibold text-sm text-[#ffffff] mb-2">
                        Spatial Grid Blogs
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Insights, stories, and updates from <br /> the world of
                        XR and Spatial AI.
                      </p>
                    </div>
                  </div>

                  <div
                    onClick={() => navigationFunction('/university-alliance')}
                    className="flex items-center md:items-start gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center flex-shrink-0">
                      <img src={iconsPath?.universityAlliance} alt="" />
                    </div>
                    <div className="text-left cursor-pointer">
                      <h2 className="font-semibold text-sm text-[#ffffff] mb-2">
                        University Alliance
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Driving academic innovation through XR <br /> research
                        and industry collaborations.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-2 md:gap-8">
                  <div
                    onClick={() => navigationFunction('/spatialgrid-research')}
                    className="flex items-center md:items-start gap-3 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center flex-shrink-0">
                      <img src={iconsPath?.spatialgridResearch} alt="" />
                    </div>
                    <div className="text-left cursor-pointer">
                      <h2 className="font-semibold text-sm text-[#ffffff] mb-2">
                        Spatial Grid Research
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Advancing the science of spatial <br /> computing
                        through deep R&D.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dropdown2>
    );
  }
);

export const IndustriesDropdown = React.memo(
  ({ isOpen, closeModal, setIsMobileMenuOpen }) => {
    const navigate = useNavigate();

    const navigationFunction = (path) => {
      navigate(path);
      closeModal();
    };

    return (
      <Dropdown2 solutions={true} isOpen={isOpen}>
        <div className=" flex gap-3 md:gap-0 p-6  md:p-8 !rounded-[50px] text-white">
          <div className="block md:hidden mb-5">
            <button
              onClick={() => {
                closeModal();
                setIsMobileMenuOpen(true);
              }}
              className="bg-[#252729] h-8 w-8 rounded-full flex items-center justify-center"
            >
              <img
                className="h-4 w-4 object-contain"
                src={iconsPath?.leftIcon}
                alt="menu"
              />
            </button>
          </div>

          {/* Headings */}
          <div className="flex flex-col ">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-3">
              <h1 className="text-[18px] font-bold  tracking-wide text-nowrap text-[#ffffff] uppercase">
                Industries
              </h1>
              <p
                className="text-[#EE2B2A] cursor-pointer"
                onClick={() => navigationFunction('/all-industries')}
              >
                See All Industries →
              </p>
            </div>
            <div className="hidden md:block h-[1px] bg-[#ffffff] bg-opacity-50 mb-5"></div>

            {/* 4-Column Layout */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-12">
              {[0, 1, 2].map((colIndex) => (
                <div key={colIndex} className="flex flex-col gap-2 md:gap-4">
                  {industries
                    .slice(colIndex * 3, colIndex * 3 + 3)
                    .map((industry, index) => (
                      <div
                        key={index}
                        onClick={() => navigationFunction(industry.path)}
                        className="flex items-center gap-3 hover:opacity-90 hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                      >
                        <div className="bg-[#2A2B2F] rounded-[5px] h-12 w-12 flex items-center justify-center p-2">
                          <img src={industry.icon} alt={industry.name} />
                        </div>

                        <span className="text-[#ffffff] font-normal text-[14px]">
                          {industry.name}
                        </span>
                      </div>
                    ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Dropdown2>
    );
  }
);

export const AboutDropdown = React.memo(
  ({ isOpen, closeModal, setIsMobileMenuOpen }) => {
    const navigate = useNavigate();

    const navigationFunction = (path) => {
      navigate(path);
      closeModal();
    };

    return (
      <Dropdown2 about={true} isOpen={isOpen}>
        <div className="flex gap-5 md:gap-0  text-white p-6  md:p-8 !rounded-[50px]">
          <div className="block md:hidden mb-5">
            <button
              onClick={() => {
                closeModal();
                setIsMobileMenuOpen(true);
              }}
              className="bg-[#252729] h-8 w-8 rounded-full flex items-center justify-center"
            >
              <img
                className="h-4 w-4 object-contain"
                src={iconsPath?.leftIcon}
                alt="menu"
              />
            </button>
          </div>

          <div
            className="flex flex-col md:grid md:gap-12 gap-4"
            style={{ gridTemplateColumns: '1fr 0.6fr' }}
          >
            {/* Spatial Grid Platform */}
            <div className="flex flex-col">
              <h1 className="text-[18px] font-bold mb-3 tracking-wide text-[#ffffff]">
                COMPANY
              </h1>
              <div className=" hidden md:block h-[1px] bg-[#ffffff] bg-opacity-50 mb-5"></div>
              <div className="flex flex-col md:flex-row gap-2 md:gap-10 ">
                <div className="flex flex-col gap-2 md:gap-8">
                  <div
                    onClick={() => navigationFunction('/about-us')}
                    className="flex items-center md:items-start gap-3 h-[78px] hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.whoAre} alt="" />
                    </div>
                    <div className="cursor-pointer">
                      <h2 className="font-semibold   text-sm text-[#ffffff] mb-2">
                        Who we are
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Building the future of spatial computing{' '}
                      </p>
                    </div>
                  </div>
                  <div
                    onClick={() => navigationFunction('/gridventure')}
                    className="flex items-center md:items-start gap-3 h-[80px] hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.venture} alt="" />
                    </div>
                    <div className="cursor-pointer">
                      <h2 className="font-semibold    text-sm text-[#ffffff] mb-2">
                        Spatial Grid Ventures
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Investing in breakthrough ideas across <br /> XR, AI,
                        and frontier technologies.
                      </p>
                    </div>
                  </div>
                  <div
                    onClick={() => navigationFunction('/press')}
                    className="flex items-center md:items-start gap-3 h-[80px] hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.press} alt="" />
                    </div>
                    <div className="cursor-pointer">
                      <h2 className="font-semibold    text-sm text-[#ffffff] mb-2">
                        Press
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        News, stories, and media insights <br /> from the
                        Spatial Grid journey.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-2 md:gap-8">
                  <div
                    onClick={() => navigationFunction('/ourteam')}
                    className="flex items-center md:items-start gap-3 h-[80px] hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.team} alt="" />
                    </div>
                    <div className="">
                      <h2 className="font-semibold    text-sm text-[#ffffff] mb-2">
                        Our Team
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        A multidisciplinary team shaping the <br /> next era of
                        XR and AI.
                      </p>
                    </div>
                  </div>

                  <div
                    onClick={() => navigationFunction('/security-and-trust')}
                    className="flex items-center md:items-start gap-3 h-[80px] hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.security} alt="" />
                    </div>
                    <div className="cursor-pointer">
                      <h2 className="font-semibold   text-sm text-[#ffffff] mb-2">
                        Security & Trust
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Enterprise-grade security built for <br /> reliability,
                        privacy, and compliance.
                      </p>
                    </div>
                  </div>

                  <div
                    onClick={() => navigationFunction('/contact-us')}
                    className="flex items-start gap-3 h-[80px] hover:bg-[#FFFFFF14] rounded-lg p-2"
                  >
                    <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                      <img src={iconsPath?.contactUs} alt="" />
                    </div>
                    <div className="cursor-pointer">
                      <h2 className="font-semibold   text-sm text-[#ffffff] mb-2">
                        Contact Us
                      </h2>
                      <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                        Connect with our team for partnerships, <br /> support,
                        and collaboration.
                      </p>
                    </div>
                  </div>
                  <div className=" block md:hidden h-[1px] bg-[#ffffff] opacity-50 "></div>
                </div>
              </div>
            </div>

            {/* Integration & OS */}
            <div className="flex flex-col">
              <h1 className="text-[18px] font-bold mb-3 tracking-wide text-[#ffffff]">
                CAREERS
              </h1>
              <div className=" hidden md:block h-[1px] bg-[#ffffff] opacity-50 mb-5"></div>
              <div
                onClick={() => navigationFunction('/careers')}
                className="flex items-center md:items-start gap-3 h-[80px] hover:bg-[#FFFFFF14] rounded-lg p-2 cursor-pointer"
              >
                <div className="bg-[#2A2B2F] h-12 w-12 rounded-[5px] p-2 flex items-center justify-center">
                  <img src={iconsPath?.position} alt="" />
                </div>
                <div className="cursor-pointer">
                  <h2 className="font-semibold   text-sm text-[#ffffff] mb-2">
                    Open Positions
                  </h2>
                  <p className="text-[12px] text-[#ffffff] opacity-50 hidden md:block">
                    Join us— Build the future of immersive technology, <br />{' '}
                    where innovation meets impact in spatial computing.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dropdown2>
    );
  }
);
